import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();
    const { processSessionId } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        // Prevent double processing in StrictMode
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const processAuth = async () => {
            // Extract session_id from URL hash
            const hash = location.hash;
            const params = new URLSearchParams(hash.replace('#', ''));
            const sessionId = params.get('session_id');

            if (sessionId) {
                const user = await processSessionId(sessionId);
                if (user) {
                    // Navigate to dashboard with user data
                    navigate('/dashboard', { state: { user }, replace: true });
                } else {
                    navigate('/', { replace: true });
                }
            } else {
                navigate('/', { replace: true });
            }
        };

        processAuth();
    }, [location, navigate, processSessionId]);

    return (
        <div className="min-h-screen bg-void flex items-center justify-center">
            <div className="text-center">
                <Loader2 className="w-8 h-8 text-acid animate-spin mx-auto mb-4" />
                <p className="text-muted-foreground font-mono text-sm">Authenticating...</p>
            </div>
        </div>
    );
}
